import React, { useEffect, useState } from 'react';
import Page from '../../Components/Page';
import { getWelcomeData, updateWelcomeData } from '../../controllers/welcome.controller';
import toast from 'react-hot-toast';

const WelcomeSection = () => {
  const [welcomeMessage, setwelcomeMessage] = useState('Welcome to SAB Campus');
  const [previewValues, setPreviewValues] = useState([
    { title: 'Graduates', value: '' },
    { title: 'Faculty Members', value: '' },
    { title: 'Employability Rate', value: '' },
    { title: 'Years of Excellence', value: '' },
  ]);

  useEffect(() => {
    const fetchApiData = async () => {
      try {
        const res = await getWelcomeData();

        if (res.status === 200) {
          const apiData = res?.data?.data?.[0];

          setwelcomeMessage(apiData.welcome_message);

          setPreviewValues([
            { title: 'Graduates', value: apiData.graduates },
            { title: 'Faculty Members', value: apiData.faculty_members },
            { title: 'Employability Rate', value: apiData.employability_rate },
            { title: 'Years of Excellence', value: apiData.years_of_excellence },
          ]);
        }
      } catch (error) {
        toast.error('Failed to fetch data');
        console.error(error);
      }
    };

    fetchApiData();
  }, []);

  const handleWelcomeChange = (e) => {
    setwelcomeMessage(e.target.value);
  };

  const handlePreviewChange = (index, key, value) => {
    setPreviewValues((prev) => {
      const updated = [...prev];
      updated[index][key] = value;
      return updated;
    });
  };


  

  const handleSubmit = async () => {
    if (!welcomeMessage.trim()) {
      toast.error('Welcome Message cannot be empty.');
      return;
    }
  
    //const hasEmptyFields = previewValues.some((item) => !item.value.trim());
    const hasEmptyFields = previewValues.some((item) => {
      return !String(item.value).trim();
    });
    if (hasEmptyFields) {
      toast.error('Please fill out all fields.');
      return;
    }
  
    try {
      toast.loading('Submitting changes...');
  
      const updatedData = {
        id: 1, // Replace this with the actual ID for the data you are updating.
        welcome_message: welcomeMessage,
        graduates: previewValues.find((item) => item.title === 'Graduates')?.value,
        faculty_members: previewValues.find((item) => item.title === 'Faculty Members')?.value,
        employability_rate: previewValues.find((item) => item.title === 'Employability Rate')?.value,
        years_of_excellence: previewValues.find((item) => item.title === 'Years of Excellence')?.value,
      };
  
      const response = await updateWelcomeData(updatedData);
  
      toast.dismiss();
      if (response.status === 200) {
        toast.success('Data updated successfully!');
      } else {
        throw new Error('Unexpected response');
      }
    } catch (error) {
      toast.dismiss();
      toast.error('Failed to update data');
      console.error(error);
    }
  };
  



  return (
    <Page className="px-8 py-6">
      <div className="p-6 mx-auto bg-white rounded-lg shadow-md">
        <h1 className="text-xl font-bold text-gray-700 mb-4">
          Welcome Section Management
        </h1>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
         
          <div className="mb-6">
            <label className="block text-gray-600 font-medium mb-2" htmlFor="welcomeMessage">
              Add Welcome Message
            </label>
            <input
              id="welcomeMessage"
              type="text"
              value={welcomeMessage}
              onChange={handleWelcomeChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

     
          <div className="mt-6">
            <h2 className="text-lg font-semibold text-gray-600 mb-4">
              Edit Preview Panel Values
            </h2>

            <div className="flex flex-col">
              {previewValues.map((item, index) => (
                <div key={index} className="mb-4 flex gap-4">
                  <input
                    type="text"
                    value={item.title}
                    readOnly
                    className="w-1/3 px-4 py-2 border rounded-lg"
                  />
                  <input
                    type="text"
                    value={item.value}
                    onChange={(e) => handlePreviewChange(index, 'value', e.target.value)}
                    className="w-2/3 px-4 py-2 border rounded-lg"
                  />
                </div>
              ))}
            </div>
          </div>

     
          <div className="mt-4 flex justify-center">
            <button
              type="submit"
              className="bg-[#92288C] text-white py-2 px-4 rounded-lg hover:bg-[#92288C]"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </Page>
  );
};

export default WelcomeSection;
